import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0af3a359"
import script from "./receiveAsset.js?vue&type=script&lang=js&external"
export * from "./receiveAsset.js?vue&type=script&lang=js&external"
import style0 from "./receiveAsset.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports